module.exports = __webpack_public_path__ + "img/10551390_S.71f734d6.png";